export default {
    methods: {
        formatMessageDateShort (messageDatetime) {
            var formatted = ''
            var now = this.$moment()
            var messageDate = this.$moment(messageDatetime)
            if (messageDate.format('YYYY-MM-DD') === now.format('YYYY-MM-DD')) {
                formatted = messageDate.format('HH:mm')
            } else if (messageDate.format('YYYY-MM-DD') === now.subtract(1, 'day').format('YYYY-MM-DD')) {
                formatted = 'gisteren'
            } else if (now.diff(messageDate, 'days') < 7) {
                formatted = messageDate.format('dddd')
            } else {
                formatted = messageDate.format('DD-MM-YYYY')
            }
            return formatted.charAt(0).toUpperCase() + formatted.slice(1)
        },
        formatMessageDateLong (messageDatetime) {
            var formatted = ''
            var now = this.$moment()
            var messageDate = this.$moment(messageDatetime)
            if (messageDate.format('YYYY-MM-DD') === now.format('YYYY-MM-DD')) {
                formatted = 'vandaag om ' + messageDate.format('HH:mm')
            } else if (messageDate.format('YYYY-MM-DD') === now.subtract(1, 'day').format('YYYY-MM-DD')) {
                formatted = 'gisteren om ' + messageDate.format('HH:mm')
            } else if (now.diff(messageDate, 'days') < 7) {
                formatted = messageDate.format('dddd') + ' om ' + messageDate.format('HH:mm')
            } else if (now.format('YYYY') === messageDate.format('YYYY')) {
                formatted = messageDate.format('dddd D MMMM') + ' om ' + messageDate.format('HH:mm')
            } else {
                formatted = messageDate.format('dddd D MMMM YYYY') + ' om ' + messageDate.format('HH:mm')
            }
            return formatted.charAt(0).toUpperCase() + formatted.slice(1)
        }
    }
}
